export const CREATED = 'Created';
export const VOID = 'Void';
export const FAILED = 'Failed';
export const RUNNING = 'Running';
export const SUCCESS = 'Success';
export const CANCELLED = 'Cancelled';
export const PAUSE = 'Pause';
export const PAUSED = 'Paused';
export const NONE = 'None';
export const RESUME = 'Resume';
export const EMPTY = 'EMPTY';
export const PENDING = 'Pending';
export const USE_CASE = 'UseCase';
export const API = 'api';
export const TESTING = 'Testing';
export const PRODUCTION = 'Production';
export const LIVE = 'Live';
export const ACTIVE = 'Active';
export const TERMINATED = 'Terminated';

export const TEST_STATUSES = {
  CREATED,
  VOID,
  FAILED,
  RUNNING,
  SUCCESS,
  CANCELLED,
  PAUSE,
  RESUME,
  EMPTY,
  PENDING,
  ACTIVE,
  TERMINATED,
} as const;

export const TestTabs = {
  OVERVIEW: 'testDetails_tab_overview',
  CONSOLE: 'testDetails_tab_console',
  TEST_DATA: 'testDetails_tab_test_data',
} as const;
